'use strict';
require('../../company/blogs/CompanyMessageService.js');

function CompanyGuestPublicationBlogDetailCtrl(
  $scope,
  $stateParams,
  publication,
  translations,
  posts,
  $sce
) {
  $scope.publication         = publication;
  $scope.translations        = translations;
  $scope.posts               = posts.slice(0, 21);
  $scope.translations        = translations;
  $scope.currentPage         = $stateParams.page|0;
  $scope.hasMore             = posts.length > 21;

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
      'content': '',
      'template': 'partials/company-guest/blog/detail/latest.html',
      'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;
}

CompanyGuestPublicationBlogDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }).$promise;
  }],
  posts: ['CompanyPublicationBlogService', '$stateParams', function(CompanyPublicationBlogService, $stateParams){
    return CompanyPublicationBlogService.query({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         22,
      offset:        ($stateParams.page|0) * 21
    }).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }]
};

module.exports = CompanyGuestPublicationBlogDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPublicationBlogDetailCtrl', [
  '$scope',
  '$stateParams',
  'publication',
  'translations',
  'posts',
  '$sce',
  CompanyGuestPublicationBlogDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/blog/CompanyGuestPublicationBlogDetailCtrl.js
// module id = 285
// module chunks = 0